<template>
  <iframe id="personal-support-chat" class="chat-container" :src="chatUrl" v-if="isAuthorized"></iframe>

  <div class="unauthorized-container" v-else>
    <div>ไม่มีสิทธิ์เข้าใช้งาน Ruejai Chat</div>
    <div>ติดต่อผู้ดูแลระบบหากคิดว่าเป็นข้อผิดพลาด</div>
  </div>
</template>

<script>
import Axios from 'axios';

import { getCookie, Auth } from "@/lib/cookie";
import { getAccessToken } from '@/god';
import { SIDE_NAV_BAR_FEATURE } from "@/config/enums";

async function getNewAccessToken() {
  const refreshToken = getCookie(Auth.RefreshToken);

  const response = await Axios.post(
    `${process.env.HOST}/api/admin/auth/retoken`,
    {},
    {
      headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    }
  )

  return response.data.accessToken.accessToken
}

export default {
  name: "PersonalSupportChatView",
  computed: {
    chatUrl() {
      const token = getAccessToken()
      const chatHost = process.env.RUEJAI_CHAT_HOST
      const { chatRoomId, messageNo } = this.$route.query

      if (chatRoomId) {
        const messageQuery = messageNo
          ? `&messageNo=${encodeURIComponent(messageNo)}`
          : ""

        return `${chatHost}/ruejai-chat/admins/personal-support/chat-rooms/${chatRoomId}/?token=${token}${messageQuery}`;
      }

      return `${chatHost}/ruejai-chat/admins/personal-support/?token=${token}`;
    },
    isAuthorized() {
      const permissions = JSON.parse(localStorage.getItem("adminRolePermission")).features ?? []

      return permissions.find(permission => permission.featureName === SIDE_NAV_BAR_FEATURE.CHAT);
    },
  },
  mounted() {
    window.onmessage = this.handleMessage
  },
  beforeDestroy() {
    if (window.onmessage === this.handleMessage) {
      window.onmessage = null
    }
  },
  methods: {
    async handleMessage(event) {
      if (event.data === "TOKEN_EXPIRED") {
        const newAccessToken = await getNewAccessToken()

        if (!newAccessToken) {
          // eslint-disable-next-line no-console
          console.error("CHAT: Failed to get new access token")
          return
        }

        const iframe = document.getElementById("personal-support-chat")

        iframe.contentWindow.postMessage(
          JSON.stringify({ type: "NEW_TOKEN", payload: newAccessToken }),
          "*",
        )
      } else if (event.data === "RELOAD") {
        window.location.reload()
      } else if (
        typeof event.data === "string" &&
        event.data.startsWith("URL_CHANGED")
      ) {
        const newIframeUrl = event.data.split(" ").slice(1).join(" ")
        const chatRoomId =
          new URL(newIframeUrl).searchParams.get("chatRoomId")

        const newUrl = chatRoomId
          ? `/admins/personal-support-chat/?chatRoomId=${chatRoomId}`
          : `/admins/personal-support-chat/`

        window.history.replaceState(null, "", newUrl)
      }
    },
  }
};
</script>

<style scoped>
.chat-container {
  width: 100%;
  height: 100dvh;
  border: none;
  outline: none;
}

.unauthorized-container {
  width: 100%;
  height: 100dvh;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
